// import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { LeftStar } from '@/components/icons'
import { SidebarHeader, SidebarTrigger } from '@/components/ui/sidebar'
import { XIcon } from 'lucide-react'

export function AppSidebarHeader() {
  return (
    
    <SidebarHeader className="relative mx-9 mb-6 mt-9 flex flex-row justify-between p-0 font-darkergrotesque text-xl font-bold">
      <div>
        <div className="absolute left-[-58px] top-[-5px]">
          <LeftStar className="h-[50px]" />
        </div>
        <h1 className="z-50 font-darkergrotesque text-xl font-bold text-zinc-950 mt-1">
            Contester
        </h1>
      </div>
      <SidebarTrigger>
        <XIcon className="h-6 w-6" />
      </SidebarTrigger>
    </SidebarHeader>
  )
}
